import { render, staticRenderFns } from "./a2.vue?vue&type=template&id=2a25fa56&scoped=true&"
import script from "./a2.vue?vue&type=script&lang=js&"
export * from "./a2.vue?vue&type=script&lang=js&"
import style0 from "./a2.vue?vue&type=style&index=0&id=2a25fa56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a25fa56",
  null
  
)

export default component.exports